<template>
  <page-wrapper
    :isLoading="isLoading"
    :hasFilters="true"
    @submitFilters="setPageNumberAndFilters"
  >
    <template #title> لیست گروه‌بندی ها </template>
    <template #filters>
      <search-input
        inputId="searchCommand"
        inputLabel="جستجوی عنوان"
        inputPlaceholder="مکالمه آزاد"
        :inputValue="priceCategoryFilters.title"
        v-model="priceCategoryFilters.title"
        @enter="setPageNumberAndFilters"
      ></search-input>
      <search-input
        inputId="durationMinute"
        inputLabel="مدت زمان گروه‌بندی"
        inputPlaceholder="40"
        :inputValue="priceCategoryFilters.durationMinute"
        v-model="priceCategoryFilters.durationMinute"
        @enter="setPageNumberAndFilters"
      ></search-input>
      <search-input
        inputId="userBasePaymentPrice"
        inputLabel="قیمت پایه زبان آموز"
        inputPlaceholder="40000"
        :inputValue="priceCategoryFilters.userBasePaymentPrice"
        v-model="priceCategoryFilters.userBasePaymentPrice"
        @enter="setPageNumberAndFilters"
      ></search-input>
      <search-input
        inputId="masterBasePaymentPrice"
        inputLabel="قیمت پایه استاد"
        inputPlaceholder="25000"
        :inputValue="priceCategoryFilters.masterBasePaymentPrice"
        v-model="priceCategoryFilters.masterBasePaymentPrice"
        @enter="setPageNumberAndFilters"
      ></search-input>
      <CustomSelect
        class="w-24 filters-width"
        inputId="hasPenalty"
        inputLabel="وضعیت جریمه گروه"
        :customOptions="hasPenaltyOptions"
        v-model="priceCategoryFilters.hasPenalty"
        @getSelectedOption="setHasPenalty"
      ></CustomSelect>
    </template>
    <custom-table
      v-if="priceCategoriesList && priceCategoriesList.length"
      :pageNumber="priceCategoryFilters.pageNumber"
      :count="priceCategoryFilters.count"
      :totalCount="totalCount"
      :tableColumns="myTableColumns"
      :tableItems="priceCategoriesList"
      @changePage="changePage"
    >
      <template #durationMinute="data">
        {{ data.item.durationMinute }} دقیقه
      </template>

      <template #userBasePaymentPrice="data">
        {{ Intl.NumberFormat("en-US").format(data.item.userBasePaymentPrice) }}
        تومان
      </template>
      <template #masterBasePaymentPrice="data">
        {{
          Intl.NumberFormat("en-US").format(data.item.masterBasePaymentPrice)
        }}
        تومان
      </template>
      <template #hasPenalty="data">
        <div class="d-flex align-items-center justify-content-center">
          <b-badge
            class="font-weight-normal text-center"
            :variant="data.item.hasPenalty ? 'danger' : 'success'"
          >
            {{ data.item.hasPenalty ? "دارد" : "ندارد" }}
          </b-badge>
        </div>
      </template>
      <template #isShow="data">
        <div class="d-flex align-items-center justify-content-center">
          <b-badge
            class="font-weight-normal text-center"
            :variant="data.item.isShow ? 'success' : 'danger'"
          >
            {{ data.item.isShow ? "فعال" : "غیر فعال" }}
          </b-badge>
        </div>
      </template>

      <template #isPrivate="data">
        <div class="d-flex align-items-center justify-content-center">
          <b-badge
            class="font-weight-normal text-center"
            :variant="data.item.isPrivate ? 'success' : 'danger'"
          >
            {{ data.item.isPrivate ? "خصوصی" : "عمومی" }}
          </b-badge>
        </div>
      </template>


      <template #actions="data">
        <div class="d-flex align-items-center">
          <b-link :to="`/apps/groups/${data.item.id}`" class="mr-2">
            <feather-icon class="text-primary" icon="EditIcon" size="20" />
          </b-link>
          <div
            style="cursor: pointer"
            @click="renderDeleteConfirmation(data.item)"
          >
            <feather-icon
              :class="data.item.isShow ? 'text-danger' : 'text-success'"
              :icon="data.item.isShow ? 'StopCircleIcon' : 'PlayCircleIcon'"
              size="20"
            />
          </div>
        </div>
      </template>
    </custom-table>
    <!-- <price-category-delete-confirm-modal
      :selectedPriceCategory="tempPriceCategory"
      @refetch="clearTempPriceCategoryAndRefetch"
    ></price-category-delete-confirm-modal> -->
    <price-category-toggle-is-show-confirmation-modal
      :selectedPriceCategory="tempPriceCategory"
      @refetch="clearTempPriceCategoryAndRefetch"
    >
    </price-category-toggle-is-show-confirmation-modal>
  </page-wrapper>
</template>

<script>
export default {
  mounted() {
    if (this.computedPageRouteQuery) {
      this.priceCategoryFilters.pageNumber = this.computedPageRouteQuery;
    } else {
      this.priceCategoryFilters.pageNumber = 1;
    }
    this.getPriceCategories();
  },
  data() {
    return {
      isLoading: false,
      priceCategoriesList: null,
      priceCategoryFilters: {
        title: null,
        durationMinute: null,
        userBasePaymentPrice: null,
        masterBasePaymentPrice: null,
        hasPenalty: null,
        pageNumber: 1,
        count: 10,
      },
      hasPenaltyOptions: [
        {
          value: null,
          text: "همه",
        },
        {
          value: true,
          text: "با جریمه",
        },
        {
          value: false,
          text: "بدون جریمه",
        },
      ],
      hasPrivateOptions: [
        {
          value: null,
          text: "همه",
        },
        {
          value: true,
          text: "خصوصی",
        },
        {
          value: false,
          text: "عمومی",
        },
      ],
      myTableColumns: [
        {
          key: "id",
          label: "شناسه گروه",
        },
        {
          key: "title",
          label: "عنوان گروه",
        },
        {
          key: "langTitle",
          label: "زبان گروه",
        },
        {
          key: "durationMinute",
          label: "مدت زمان جلسه",
        },
        {
          key: "userBasePaymentPrice",
          label: "قیمت پایه زبان آموز",
        },
        {
          key: "masterBasePaymentPrice",
          label: "قیمت پایه استاد",
        },
        {
          key: "isShow",
          label: "وضعیت گروه‌بندی",
        },
        {
          key: "isPrivate",
          label:"وضعیت خصوصی"
        },
        {
          key: "hasPenalty",
          label: "وضعیت جریمه",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      totalCount: null,
      tempPriceCategory: null,
    };
  },
  methods: {
    clearTempPriceCategoryAndRefetch() {
      this.$bvModal.hide("price-category-toggle-confirmation-modal");
      this.tempPriceCategory = null;
      this.getPriceCategories();
    },
    setHasPenalty(hasPenalty) {
      this.priceCategoryFilters.hasPenalty = hasPenalty;
      this.setPageNumberAndFilters();
    },
    setIsPrivate(isPrivate) {
      this.priceCategoryFilters.isPrivate = isPrivate;
      this.setPageNumberAndFilters();
    },
    setPageNumberAndFilters() {
      this.priceCategoryFilters.pageNumber = 1;
      this.getPriceCategories();
    },
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: pageNumber,
        },
      });
    },
    changePage(pageNumber) {
      this.priceCategoryFilters.pageNumber = pageNumber;
      this.setPageNumberQuery(pageNumber);
      this.getPriceCategories();
    },
    renderDeleteConfirmation(priceCategory) {
      this.tempPriceCategory = JSON.parse(JSON.stringify(priceCategory));
      this.$bvModal.show("price-category-toggle-confirmation-modal");
    },
    createPriceCategoryPayload() {
      // Handle filters here
      let payload = {};
      Object.keys(this.priceCategoryFilters).forEach((key) => {
        if (
          this.priceCategoryFilters[key] != null &&
          this.priceCategoryFilters[key] !== ""
        ) {
          payload[key] = this.priceCategoryFilters[key];
        }
      });
      return payload;
    },
    async getPriceCategories() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllPriceCategories = new GetAllPriceCategories(_this);
        getAllPriceCategories.setRequestParamDataObj(
          _this.createPriceCategoryPayload()
        );
        await getAllPriceCategories.fetch((res) => {
          _this.priceCategoriesList = res.data;
          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    pageNumber() {
      return this.priceCategoryFilters.pageNumber;
    },
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.page) {
        return this.$route.query.page;
      }
      return null;
    },
  },
  components: {
    BLink,
    BBadge,
    PageWrapper,
    CustomTable,
    SearchInput,
    CustomSelect,
    PriceCategoryToggleIsShowConfirmationModal,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
import PriceCategoryToggleIsShowConfirmationModal from "@/views/components/PriceCategory/PriceCategoryToggleIsShowConfirmationModal.vue";
import { BLink, BBadge } from "bootstrap-vue";
import { GetAllPriceCategories } from "@/libs/Api/PriceCategory";
</script>
